<template>
  <div class="reminder-add">
    <el-form ref="reminderForm" label-position="top" :model="reminderList" size="small" class="content"
             label-width="90px">
      <el-form-item class="textarea" label-width="0">
        <el-input
          type="textarea"
          :rows="4"
          maxlength="70"
          show-word-limit
          :placeholder="$xinI18n('请输入备忘','Home-qingshurubeiwang')"
          v-model="reminderList.reminderData"
        >
        </el-input>
      </el-form-item>
      <el-form-item :label="$xinI18n('时间','Common-shijian')">
        <el-col :span="7">
          <el-date-picker
            v-model="reminderList.yearmoDay"
            type="date"
            disabled
            :placeholder="$xinI18n('选择日期','DatePicker-xuanzeriqi')">
          </el-date-picker>
        </el-col>
        <el-col :span="7" class="m_l8">
          <el-time-picker
            class="reminder-time-picker"
            v-model="reminderList.time"
            format="HH:mm"
            prefix-icon="null"
            :clearable="false"
            :placeholder="$xinI18n('选择时间','DateTime-xuanzeshijian')">
          </el-time-picker>
        </el-col>
      </el-form-item>
      <el-form-item :label="$xinI18n('提醒','ApplyV2-BatchAdjust-getUpdateAdjustFormRules-tixing')">
        <el-col :span="7">
          <el-select v-model="reminderList.openRemind" :placeholder="$xinI18n('请选择','Common-qingxuanze')">
            <el-option v-for="type in remindOpenType"
                       :key="type.id"
                       :label="type.name"
                       :value="type.id">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="7" class="m_l8" v-if="reminderList.openRemind === 1">
          <el-select v-model="reminderList.remindAdvanceType" :placeholder="$xinI18n('请选择','Common-qingxuanze')">
            <el-option v-for="type in advanceType"
                       :key="type.id"
                       :label="type.name"
                       :value="type.id">
            </el-option>
          </el-select>
        </el-col>
      </el-form-item>
      <el-form-item :label="$xinI18n('提醒方式','appraisal-okr-tixingfangshi')" class="is-required remind-type-ck" prop="remindType"
                    v-if="reminderList.openRemind === 1"
                    :rules="[{ type: 'array', required: true, message: $xinI18n('请至少选择一种提醒方式','Home-qingzhishaoquanzetixingfangshi'), trigger: 'change' }]">
        <el-checkbox-group v-model="reminderList.remindType">
          <el-checkbox v-for="type in remindType" :label="type.id" :key="type.id">{{type.name}}</el-checkbox>
        </el-checkbox-group>
        <el-tooltip effect="dark" :content="$xinI18n('总公司超管、高管、分公司超管，仅可通过短信发送备忘提醒','Home-jinketongguoduanxinbeiwang')" placement="right">
          <xin-icon xin-type="question"></xin-icon>
        </el-tooltip>
      </el-form-item>
    </el-form>
  </div>
</template>

<script lang="ts">
  import {Component, Prop, Vue} from 'vue-property-decorator';
  import {OpenDetail} from '@/module/home/entities/open-detail';
  import {namespace} from 'vuex-class';
  import {HomeApi} from '@/module/home/service/home-api.service';
  import moment from 'moment';
  import {HomeReminder} from '@/module/home/entities/home-reminder';

  const moduleInfra = namespace('moduleInfra');

  @Component({
    name: 'reminder-add',
  })
  export default class ReminderAdd extends Vue {
    @moduleInfra.Getter('getRoleType') public roleType!: number;
    @Prop({required: true}) public selectedDate!: string;
    @Prop({required: true}) public openDetail!: OpenDetail;
    @Prop({required: false}) public srcReminder!: HomeReminder;

    public isEditReminder = false;

    public remindOpenType = [
      {id: 0, name: window.$xinI18n('不提醒','Home-butixing')},
      {id: 1, name: window.$xinI18n('提醒','ApplyV2-BatchAdjust-getUpdateAdjustFormRules-tixing')}
    ];
    public advanceType = [
      {id: 0, name: window.$xinI18n('实时','Home-remind-shishi')},
      {id: 1, name: window.$xinI18n('{#1}分钟前','Okr-OActivity-xxfenzhongqian',[5])},
      {id: 2, name: window.$xinI18n('{#1}分钟前','Okr-OActivity-xxfenzhongqian',[15])},
      {id: 3, name: window.$xinI18n('{#1}分钟前','Okr-OActivity-xxfenzhongqian',[30])},
      {id: 4, name: window.$xinI18n('{#1}小时前','Home-remind-xxxiaoshiqian',[1])},
      {id: 5, name: window.$xinI18n('{#1}小时前','Home-remind-xxxiaoshiqian',[2])},
      {id: 6, name: window.$xinI18n('{#1}天前','Home-remind-xxtianqian',[1])},
      {id: 7, name: window.$xinI18n('{#1}天前','Home-remind-xxtianqian',[2])},
      {id: 8, name: window.$xinI18n('一周前','Home-remind-yizhouqian')},
    ];
    public reminderList: HomeReminder = {
      reminderData: '',
      // props-eslint-edit
      yearmoDay:'',
      time: new Date(),
      openRemind: 0,
      remindAdvanceType: 0,
      remindType: [0],
    };

    public $refs!: {
      reminderForm: any
    };

    created() {
      if (this.srcReminder) {
        console.log(this.srcReminder.yearmoDay);

        this.isEditReminder = true;
        this.reminderList = {
          reminderData: this.srcReminder.reminderData,
          yearmoDay: moment(this.srcReminder.yearmoDay, 'YYYYMMDD').toDate(),
          time: moment(this.srcReminder.time, 'HH:mm').toDate(),
          openRemind: this.srcReminder.openRemind,
          remindAdvanceType: this.srcReminder.remindAdvanceType,
          remindType: this.srcReminder.remindType
        };
      }else{
        this.reminderList = {
            reminderData: '',
            yearmoDay: moment(this.selectedDate, 'YYYY/MM/DD').toDate(),
            time: new Date(),
            openRemind: 0,
            remindAdvanceType: 0,
            remindType: [0],
        };
      }
      console.log(this.reminderList);
    }

    get remindType() {
      let basicType = [
        // {id: 0, name: '微信'},
        {id: 1, name: '邮件'}
      ];
      if(window.deployFunctionSwitch?.weixinNoticeTemplate === '1') {
        basicType.unshift({id: 0, name: '微信'});
      }
      //总公司超管、高管、分公司超管
      let isHighAdmin = this.roleType == 1;
      if (isHighAdmin) {
        this.reminderList.remindType = [2];
        basicType = [{id: 2, name: '短信'}];
      } else {
        if (this.openDetail.isOpenDtalk) {
          basicType.push({id: 3, name: '钉钉'});
        }
        if (this.openDetail.isOpenQywx) {
          basicType.push({id: 10, name: '企业微信'});
        }
        if (this.openDetail.isOpenYzj) {
          basicType.push({id: 11, name: '云之家'});
        }
      }
      return basicType;
    }

    public handlerSaveReminder(cb: (t: boolean) => void) {
      const yearmoDay = moment(this.reminderList.yearmoDay).format('YYYYMMDD');

      this.$refs.reminderForm.validate((valid: boolean) => {
        if (valid) {
          let postData = JSON.parse(JSON.stringify(this.reminderList));
          postData.yearmoDay = yearmoDay;
          postData.time = moment(this.reminderList.time).format('HH:mm');
          postData.remindType = this.reminderList.remindType.join(',');

          if (!this.isEditReminder) {
            HomeApi.addReminder(postData)
              .then(result => {
                if (result.status) {
                  // $$$$ 数据埋点 $$$$/
                  this.XrxsTracker.$track('a_editHomeRemind');
                  cb(true);
                }
              })
              .catch(() => {
                cb(false);
              });
          } else {
            postData.reminderId = this.srcReminder.reminderId;
            HomeApi.updateReminder(postData)
              .then(result => {
                if (result.status) {
                  // $$$$ 数据埋点 $$$$/
                  this.XrxsTracker.$track('a_editHomeRemind');
                  cb(true);
                }
              })
              .catch(() => {
                cb(false);
              });
          }
        } else {
          cb(false);
        }
      });
    }
  }
</script>

<style scoped lang="scss">
  .reminder-add {
    .el-date-editor.el-input, .el-date-editor.el-input__inner {
      width: auto;
    }

    .remind-type-ck {
      .el-checkbox-group {
        float: left;
      }

      .xin-icon {
        margin-left: 7px;
      }
    }

    ::v-deep .reminder-time-picker .el-input__inner {
      padding-left: 16px;
    }
  }
</style>
